module.exports = __webpack_public_path__ + "static/image-02-a@2x-bf02ff6ea5b8a15ba0632becc5b02251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cabify/image-02-a@2x.jpg
// module id = 338
// module chunks = 3627797113349 20562973939449 33019919093843